import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AboutUs from "../container/AboutUs/AboutUs";
import Landing from "../container/Landing/Landing";
import NewsDetail from "../container/News/NewsDetail";
import MainLayout from "./MainLayout";
// import VerticalTabs from "../container/VerticalTabs";
import ACIDTech from "../container/Technology/ACIDTech/Tech";

//import Sidebar from "../container/DownHoleTools/Menu/Sidebar";
import PageWithSidebar from "../container/DownHoleTools/SidebarMenu/SidebarMain";





const AppRoute = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Landing />} />
          {/* <Route path="dd" element={<SwellablePacker />} /> */}
          <Route path="/:index" element={<NewsDetail />} />
          <Route path="/about" element={<AboutUs />} />
          {/* <Route path="/vertical" element={<VerticalTabs />} /> */}
          <Route path="/acidtech" element={<ACIDTech />} />
          <Route path="/tool/*" element={<PageWithSidebar />} />
          {/* <Route path="/tool/*" element={<MainSideBar />} /> */}
          
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
